export const simsInventoryTableDataTestId = 'sims inventory table';
export const simsInventorySearchDataTestId = 'sims inventory search menu';
